<template>
	<div class="d-flex j-center">

		<div class="content-box">
				<div style="display: flex;height: 50px;align-items: center;">
					<div style="font-size: 14px;color: #888888;width: 220px;">banner广告提供者</div>
					<div style="font-size: 14px;color: #000000;">{{bannerDetail.company_name}}</div>
				</div>
				<div style="display: flex;height: 50px;align-items: center;">
					<div style="font-size: 14px;color: #888888;width: 220px;">付费入驻banner广告位企业</div>
					<div style="font-size: 14px;color: #000000;">{{bannerDetail.apply_company_name}}</div>
				</div>
				<div style="display: flex;height: 50px;align-items: center;">
					<div style="font-size: 14px;color: #888888;width: 220px;">入驻广告位位置</div>
					<div style="font-size: 14px;color: #000000;">{{bannerDetail.ad_sort}}号banner广告位</div>
				</div>
				<div v-if="$route.query.ad_type==2" style="display: flex;height: 50px;align-items: center;">
					<div style="font-size: 14px;color: #888888;width: 220px;">广告位价格</div>
					<div style="font-size: 14px;color: #000000;">{{bannerDetail.ad_price}}元/周</div>
				</div>
				<div v-if="$route.query.ad_type==1" style="display: flex;height: 50px;align-items: center;">
					<div style="font-size: 14px;color: #888888;width: 220px;">广告位价格</div>
					<div style="font-size: 14px;color: #000000;">免费</div>
				</div>
				<div v-if="$route.query.ad_type==2" style="display: flex;height: 50px;align-items: center;">
					<div style="font-size: 14px;color: #888888;width: 220px;">banner广告投放时间</div>
					<div style="font-size: 14px;color: #000000;">
						<el-date-picker
						v-model="datas.put_time"
						type="date"
						placeholder="选择日期"
						size="small"
						value-format="yyyy-MM-dd"
						:picker-options="pickerOptions"
						:disabled="disabled">
						</el-date-picker>
					</div>
				</div>
				<div v-if="$route.query.ad_type==2" style="display: flex;height: 50px;align-items: center;">
					<div style="font-size: 14px;color: #888888;width: 220px;">入驻广告周期</div>
					<div style="font-size: 14px;color: #000000;">
						<el-select v-model="datas.use_week" placeholder="请选择" size="small">
							<el-option
							  v-for="item in use_week"
							  :key="item.value"
							  :label="item.label"
							  :value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;height: 50px;align-items: center;">
					<div style="font-size: 14px;color: #888888;width: 220px;">广告投放费用</div>
					<div style="font-size: 14px;color: #000000;">{{bannerDetail.ad_price*datas.use_week}}元</div>
				</div>
				<div style="display: flex;">
					<div style="font-size: 14px;color: #888888;width: 220px;line-height: 50px;height: 50px;">客户广告banner图</div>
					<el-upload style="cursor: pointer;width: 350px;flex-wrap: wrap;text-align: center;margin: 15px 0;" class="d-flex j-center"
					  :action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
					  :data="{'act':'upload_photo_introduction','token':token,'user_id':user_id}"
					  :show-file-list="false"
					  :on-success="getBanner_path"
					  accept='.jpg,.png,.jpeg'>
						<img v-if="datas.banner_path" style="width: 350px;height: 150px;" :src="datas.banner_path"/>
						<div v-else style="width: 350px;height: 150px;background: #EDEDED;border-radius: 5px;color: #bbbbbb;font-size: 12px;"
						class="d-flex a-center j-center">
						  添加banner广告图(建议尺寸702px*300px)
						</div>
					</el-upload>
					
				</div>
				<div style="display: flex;">
					<div style="font-size: 14px;color: #888888;width: 220px;line-height: 50px;height: 50px;">广告banner跳转内容</div>
					<div>
						<div style="margin: 15px 0;">
							<el-select v-model="datas.jump_type" placeholder="请选择" size="small">
							    <el-option
							      v-for="item in options"
							      :key="item.value"
							      :label="item.label"
							      :value="item.value">
							    </el-option>
							</el-select>
						</div>
						<el-upload v-if="datas.jump_type==0" style="cursor: pointer;width: 350px;flex-wrap: wrap;text-align: center;margin: 15px 0;" class="d-flex j-center"
						  :action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
						  :data="{'act':'upload_photo_introduction','token':token,'user_id':user_id}"
						  :show-file-list="false"
						  :on-success="getCon_img_path"
						  accept='.jpg,.png,.jpeg'>
							<img v-if="datas.con_img_path" style="width: 350px;" :src="datas.con_img_path"/>
							<div v-else style="width: 350px;min-height: 350px;background: #EDEDED;border-radius: 5px;color: #bbbbbb;font-size: 12px;"
							class="d-flex a-center j-center">
							  添加跳转图片内容建议款对为702px，高度不限
							</div>
						</el-upload>
						<div v-if="datas.jump_type==2" style="height: 100px;">
							<div @click="showfile=true" style="height: 100px;display: flex;align-items: center;font-size: 12px;color: #888888;
							font-weight: 700;cursor: pointer;">
								<div v-if="goodsId" class="d-flex a-center" style="width: 300px;">
									<div style="height: 40px;width: 40px;">
										<img style="width: 40px;height: 40px;" :src="getCurGoods.goods_thumb" />
									</div>
									<div style="font-size: 14px;font-weight: 700;display: flex;align-items: center;
									box-sizing: border-box;padding: 6px 12px;flex: 1;">
									  <div style="height: 40px;flex: 1;font-size: 14px;color: #888888;">
										<span class="text-hide-2">{{getCurGoods.goods_name}}</span>
									  </div>
									</div>
								</div>
								选择产品/服务 <img style="width: 12px;height: 12px;" src="../../assets/order/jiantoujindian@2x.png" />
							</div>
						</div>
					</div>
				</div>
				<div style="display: flex;margin-top: 30px;font-size: 14px;">
					<div style="width: 150px;height: 36px;background: #FFFFFF;border: 2px solid #888888;
					border-radius: 4px;margin-left: 30px;color: #888888;cursor: pointer;" class="d-flex a-center j-center">
						取消
					</div>
					<div @click="ep_banner_ad_apply()" style="width: 150px;height: 36px;background: #1E69FF;border: 2px solid #1E69FF;
					border-radius: 4px;margin-left: 160px;color: #FFFFFF;cursor: pointer;" class="d-flex a-center j-center">
						提交
					</div>
				</div>
				<div class="d-flex a-center" style="color: #888888;font-size: 14px;margin-left: 43px;margin-top: 10px;">
					<img style="width: 13px;height: 13px;margin-right: 10px;" src="" />
					提交内容审核通过之后在“banner广告位中的我的广告位”付款即可
				</div>
		</div>
		<el-dialog
		  title="选择产品/服务"
		  :visible.sync="showfile"
		  width="1170px"
		  center>
		  <div style="padding: 0 20px 20px 20px;background: #F8F8F8;height: 360px;overflow-y: scroll;">
			  <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
				  <label v-for="(item,index) in goodsList" class="d-flex a-center"
				  style="width: 48%;margin-top: 20px;background: #FFFFFF;border-radius: 3px;">
					  <el-radio v-model="goodsId" :label="item.id" style="display: flex;align-items: center;padding-left: 20px;" >
						  <div style="height: 40px;width: 40px;">
						  	<img style="width: 40px;height: 40px;" :src="item.goods_thumb" />
						  </div>
					  </el-radio>
					  <div style="font-size: 14px;font-weight: 700;display: flex;align-items: center;
					  box-sizing: border-box;padding: 6px 12px;flex: 1;">
						  <div style="height: 40px;flex: 1;font-size: 14px;color: #888888;">
							<span class="text-hide-2">{{item.goods_name}}</span>
						  </div>
					  </div>
				  </label>
			  </div>
		  </div>
		  <div style="display: flex;justify-content: center;margin-top: 30px;">
			  <el-pagination
				@size-change="handleSizeChanges"
				@current-change="handleCurrentChanges"
				:current-page="curPage"
				:page-sizes="[10, 15]"
				:page-size="curSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="goodsTotal">
			  </el-pagination>
		  </div>
		  <div class="d-flex a-center j-center" style="margin-top: 20px;">
				<div @click="showfile=false" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #cccccc;
				border-radius: 4px;display: flex;align-items: center;justify-content: center;">
					取消
				</div>
				<div @click="setGoodsId()" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #1E69FF;
				border-radius: 4px;display: flex;align-items: center;justify-content: center;margin-left: 30px;">
					确定
				</div>
		  </div>
		</el-dialog>
	</div>		
</template>

<script>
	export default{
		data(){
			return{
				token: localStorage.getItem('token'),
				user_id: localStorage.getItem('user_id'),
				pickerOptions: {
					disabledDate(time){
						// console.log(Date.now() - 3600 * 1000 * 24);
						return time.getTime() < Date.now();
						// return false
					}
				},
				options: [{
				  value: '0',
				  label: '使用图片内容'
				},{
				  value: '1',
				  label: '使用企业介绍'
				},{
				  value: '2',
				  label: '使用企业产品'
				}],
				use_week: [{
				  value: '1',
				  label: '一周'
				},{
				  value: '2',
				  label: '两周'
				},{
				  value: '3',
				  label: '三周'
				},{
				  value: '4',
				  label: '四周'
				},{
				  value: '5',
				  label: '五周'
				},{
				  value: '6',
				  label: '六周'
				},{
				  value: '7',
				  label: '七周'
				},{
				  value: '8',
				  label: '八周'
				},{
				  value: '9',
				  label: '九周'
				},{
				  value: '10',
				  label: '十周'
				}],
				datas:{
					banner_path:'',
					con_img_path:'',
					jump_type:'0',
					use_week:'',
					product_id:'',
					put_time:''
				},
				goodsList:[],
				goodsId:'',
				getCurGoods:'',
				goodsTotal:'',
				curSize: 10,
				curPage:1,
				showfile:false,
				bannerDetail:'',
				disabled:false
			}
		},
		created() {
			this.ep_banner_ad_view()
			this.ep_get_banner_ad_use_date()
			this.enterprise_goods_list()
		},
		methods:{
			ep_banner_ad_apply(){
				if(this.datas.put_time == '' && this.$route.query.ad_type==2){
					this.$message({
						showClose: false,
						message: '请选择投放时间',
						type: 'error',
						offset: 350,
						duration: 1500
					})
					return
				}
				if(this.datas.use_week == '' && this.$route.query.ad_type==2){
					this.$message({
						showClose: false,
						message: '请选择广告入驻周期',
						type: 'error',
						offset: 350,
						duration: 1500
					})
					return
				}
				if(this.datas.banner_path == ''){
					this.$message({
						showClose: false,
						message: '请上传广告banner图',
						type: 'error',
						offset: 350,
						duration: 1500
					})
					return
				}
				
				let params = {
					act:'ep_banner_ad_apply',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ad_id : this.$route.query.ad_id,
					...this.datas
				}
				this.$api.enterprise_goods_list(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '提交成功请等待审核',
							type: 'success',
							offset: 350
						})
						setTimeout(()=>{
							this.$router.back()
						},2000)
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			handleSizeChanges(size) {
				this.curSize = size;
				this.enterprise_goods_list()
			},
			handleCurrentChanges(currentPage) {
				this.curPage = currentPage;
				this.enterprise_goods_list()
			},
			//获取产品列表
			enterprise_goods_list(){
				let params = {
					act:'enterprise_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status:1,
					page:this.curPage,
					size:this.curSize
				}
				
				this.$api.enterprise_goods_list(params).then((res)=>{
					if(res.code == 0){
						this.goodsList = res.data
						this.goodsTotal = res.total_records
					}
				})
			},
			setGoodsId(){
				this.showfile = false
				this.goodsList.forEach((item)=>{
					if(this.goodsId == item.id){
						this.getCurGoods = item
						this.datas.product_id = item.id
					}
				})
			},
			getBanner_path(file, fileList) {
				this.datas.banner_path = file.data
			},
			getCon_img_path(file, fileList) {
				this.datas.con_img_path = file.data
			},
			ep_banner_ad_view(){
				let param = {
					act : 'ep_banner_ad_view',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ad_id : this.$route.query.ad_id
				}
				this.$api.staff_card_list(param).then((res)=>{
					this.bannerDetail = res.data
				})
			},
			ep_get_banner_ad_use_date(){
				let param = {
					act : 'ep_get_banner_ad_use_date',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ad_id : this.$route.query.ad_id
				}
				this.$api.staff_card_list(param).then((res)=>{
					if(res.code == 0){
						res.data.predict_time_list.forEach((item,index)=>{
							if(res.data.predict_time_list.length == (index+1)){
								this.datas.put_time = item.time_end
								this.disabled = true
							}
						})
					}
				})
			}
			
		}
	}
</script>

<style scoped>
	.content-box{
		width: 1170px;
		min-height: 760px;
		background: #FFFFFF;
		border-radius: 6px;
		padding: 0px 60px 30px 330px;
		box-sizing: border-box;
		margin-top: 20px;
	}
</style>